// Setup › Teams at `/c/{slug}/setup/teams` (M1-08; core, managers). The open team's drawer is in
// the URL (`?team=`), next to the focus keys, so a reload or a shared link opens it.
import { createRoute, useNavigate } from "@tanstack/react-router";
import { TeamsScreen } from "../features/chart/teams-screen";
import { useCompany } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { setupRoute } from "./c.$slug.setup";

const ID = /^[0-9a-f-]{36}$/i;

export const setupTeamsRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "teams",
  validateSearch: (search: Record<string, unknown>) => ({
    ...validateFocusSearch(search),
    ...(typeof search.team === "string" && ID.test(search.team) ? { team: search.team } : {}),
  }),
  component: function Teams() {
    const { api } = setupTeamsRoute.useRouteContext();
    const { team } = setupTeamsRoute.useSearch();
    const navigate = useNavigate();
    return (
      <TeamsScreen
        api={api}
        company={useCompany()}
        teamId={team}
        onTeam={(id) =>
          void navigate({
            to: ".",
            search: (prev: Record<string, unknown>) => {
              const { team: _drop, ...rest } = prev;
              return id ? { ...rest, team: id } : rest;
            },
          } as never)
        }
      />
    );
  },
});
